import React, { useEffect, useState, useCallback } from "react";
import { useApp } from "../context/AppContext";
import { HardHat, Phone, Mail, Building2, User, CheckCircle2, Loader2 } from "lucide-react";

export default function SubcontractorContacts({ projectId }) {
  const { api, lang } = useApp();
  const zh = lang === "zh";
  const [contacts, setContacts] = useState(null);

  const load = useCallback(() => {
    api.get(`/projects/${projectId}/subcontractor-contacts`)
      .then(({ data }) => setContacts(data.contacts || []))
      .catch(() => setContacts([]));
  }, [api, projectId]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="border-t border-slate-100 pt-4" data-testid="subcontractor-contacts">
      <p className="text-sm font-semibold text-slate-800 flex items-center gap-1.5 mb-1">
        <HardHat className="h-4 w-4 text-brand-500" />{zh ? "分包商联系方式" : "Subcontractor Contacts"}
        {contacts && <span className="text-xs font-normal text-slate-400">· {contacts.length}</span>}
      </p>
      <p className="text-[11px] text-slate-400 mb-3">{zh ? "已确认工种的分包商及联系方式（销售视图不含合同金额与付款信息）。" : "Confirmed trades and their subcontractor contacts."}</p>

      {contacts === null ? (
        <div className="py-10 flex justify-center text-slate-400"><Loader2 className="h-5 w-5 animate-spin" /></div>
      ) : contacts.length === 0 ? (
        <div className="py-10 text-center text-slate-400 text-sm" data-testid="subcontractor-contacts-empty">
          {zh ? "暂无已确认的分包工种" : "No confirmed subcontractors yet"}
        </div>
      ) : (
        <div className="space-y-2.5">
          {contacts.map((c, i) => (
            <div key={c.tradeKey || i} data-testid={`subcontractor-contact-${c.tradeKey || i}`}
              className="rounded-xl border border-slate-200 bg-white p-3">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-sm font-semibold text-red-600">{c.tradeName}</span>
                {c.signed && (
                  <span className="text-[10px] font-semibold text-emerald-600 bg-emerald-50 border border-emerald-200 rounded-full px-1.5 py-0.5 inline-flex items-center gap-0.5">
                    <CheckCircle2 className="h-3 w-3" />{zh ? "已签约" : "Signed"}
                  </span>
                )}
              </div>
              <div className="mt-1.5 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5 text-sm">
                <span className="inline-flex items-center gap-1.5 text-slate-700"><User className="h-3.5 w-3.5 text-slate-400" />{c.subcontractorName || "—"}</span>
                {c.company && <span className="inline-flex items-center gap-1.5 text-slate-600"><Building2 className="h-3.5 w-3.5 text-slate-400" />{c.company}</span>}
                {c.phone ? (
                  <a href={`tel:${c.phone}`} className="inline-flex items-center gap-1.5 text-sky-600 hover:underline" data-testid={`subcontractor-phone-${c.tradeKey || i}`}><Phone className="h-3.5 w-3.5" />{c.phone}</a>
                ) : (
                  <span className="inline-flex items-center gap-1.5 text-slate-400"><Phone className="h-3.5 w-3.5" />{zh ? "无电话" : "No phone"}</span>
                )}
                {c.email ? (
                  <a href={`mailto:${c.email}`} className="inline-flex items-center gap-1.5 text-sky-600 hover:underline truncate"><Mail className="h-3.5 w-3.5 shrink-0" />{c.email}</a>
                ) : (
                  <span className="inline-flex items-center gap-1.5 text-slate-400"><Mail className="h-3.5 w-3.5" />{zh ? "无邮箱" : "No email"}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
